import * as storeInformation from '../services/storeInformation';
import dayjs from 'dayjs';
export default {
  namespace: 'storeInformation',
  state: {},
  effects: {
    *getAllStoreInformation({}, { call, put }) {
      const response = yield call(storeInformation.getAllStoreInformation);
      const data = response.data.areaList.map((item) => {
        if (item.name === '北京区域 BEIJING') {
          return { ...item, index: 9 };
        } else if (item.name === '上海 SHANGHAI') {
          return { ...item, index: 0 };
        } else if (item.name === '广州 GUANGZHOU') {
          return { ...item, index: 5 };
        } else if (item.name === '深圳 SHENZHEN') {
          return { ...item, index: 3 };
        } else if (item.name === '杭州 HANGZHOU') {
          return { ...item, index: 2 };
        } else if (item.name === '西安 EXA') {
          return { ...item, index: 1 };
        } else if (item.name === '常州 CHANGZHOU') {
          return { ...item, index: 4 };
        } else if (item.name === '郑州 ZHENGZHOU') {
          return { ...item, index: 6 };
        } else if (item.name === '天津 TIANJIN') {
          return { ...item, index: 7 };
        } else if (item.name === '上海商业 SHANGHAI-SY') {
          return { ...item, index: 8 };
        } else if (item.name === '华东区域 EAST') {
          return { ...item, index: 10 };
        } else if (item.name === '华南区域 SOUTH') {
          return { ...item, index: 12 };
        } else if (item.name === '西南区域 SOUTHWEST') {
          return { ...item, index: 15 };
        } else if (item.name === '西部区域 WEST') {
          return { ...item, index: 14 };
        } else if (item.name === '华中区域 CENTRAL') {
          return { ...item, index: 16 };
        } else if (item.name === '东北区域 NORTHEAST') {
          return { ...item, index: 13 };
        } else if (item.name === '华北区域 NORTH') {
          return { ...item, index: 11 };
        } else if (item.name === '香港 HONGKONG') {
          return { ...item, index: 17 };
        } else if (item.name === '澳门 MACAU') {
          return { ...item, index: 19 };
        }
        return { ...item, index: 18 };
      });
      data.sort(function (a, b) {
        //第一个参数 - 第二个参数返回从小到大排序
        return a.index - b.index;
      });
      const openNumber = data.reduce((prev, cur) => prev + cur?.openCount, 0);
      const closeNumber = data.reduce((prev, cur) => prev + cur?.closeCount, 0);
      yield put({
        type: 'save',
        payload: {
          storeList: data,
          getDtaTime: dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss'),
          openNumber,
          closeNumber,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
